// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3DTvC","loader":"Button_loader__3eWRR","cell":"Button_cell__1ePse"};